module.exports = __webpack_public_path__ + "img/sign_apply_menu.493e879c.png";